import React, { useState } from 'react';
import {
	Grid,
	TextField,
	Box,
	makeStyles,
	FormControlLabel,
	Checkbox,
	Radio,
	RadioGroup,
	FormControl,
} from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import flt from '../assets/images/flt.png';
import { useDispatch, useSelector } from 'react-redux';
import DateRange from '../components/reusableComponents/DateRange';
import DateRangeNew from '../components/reusableComponents/DateRangeNew';
import BodyText from '../components/reusableComponents/BodyText';
import TitleText from '../components/reusableComponents/TitleText';
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import { SearchReturnFormDispatch } from '../reducers/HomeReducer';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import DesktopDate from '../components/reusableComponents/DesktopDate';
import DesktopDateNew from '../components/reusableComponents/DesktopDateNew';
import DesktopDateBus from '../components/reusableComponents/DesktopDateBus';
const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiFormControl-root': {
			'& div': {
				'& div': {
					display: 'none',
				},
			},
		},
		'& .MuiInput-underline:before': {
			borderBottom: 'none',
		},
		'& .MuiInput-underline:after': {
			borderBottom: 'none',
		},
		'& input': {
			fontSize: 24,
		},
	},
	radio: {
		'& .MuiRadio-root': {
			color: 'white',
		},
		'& .MuiRadio-colorSecondary.Mui-checked': {
			color: '#f50057',
		},
		'& .MuiTypography-body1': {
			color: 'white',
			fontSize: 14,
		},
	},
}));
const SearchBus2 = () => {
	const [result, setResult] = useState([]);
	const [result2, setResult2] = useState([]);
	const classes = useStyles();
	const { city } = useSelector((state) => state.home);
	const handleRadio = (event) => {
		setValue(event.target.value);
	};
	const history = useHistory();
	const dispatch = useDispatch();
	const [data, setData] = useState(true);

	const [adult, setAdult] = useState(1);
	const [child, setChild] = useState(0);
	const [infant, setInfant] = useState(0);
	const [value, setValue] = useState('Economy');
	const [leaving, setLeaving] = useState('DEL');
	const [trip, setTrip] = useState('oneway');
	const [going, setGoing] = useState('CCU');
	const { origin, depart } = useSelector((state) => state.ui);
	let invoiceOptions = [];
	let demo = [];
	city &&
		city.data &&
		city.data.length > 0 &&
		city.data.forEach((invoice, index) => {
			invoiceOptions.push({
				code: invoice.iata_code,
				city: invoice.city,
				country: invoice.country_name,
			});
			if (index < 50) {
				demo.push({
					code: invoice.iata_code,
					city: invoice.city,
					country: invoice.country_name,
				});
			}
		});
	const handleSubmit = (data) => {
		console.log(data);

		// let formData = {
		// 	JourneyType: 1,
		// 	Origin: data.Origin,
		// 	Destination: data.Destination,
		// 	AdultCount: adult,
		// 	ChildCount: child,
		// 	InfantCount: infant,
		// 	PreferredDepartureTime: origin,
		// };
		let formData2 = {
			JourneyType: 2,
			Origin: data.Origin,
			Destination: data.Destination,
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			PreferredDepartureTime: origin,
			ReturnPreferredDepartureTime: depart,
		};
		dispatch(SearchReturnFormDispatch(formData2, history));
		// let formData3 = {
		// 	JourneyType: 2,
		// 	Origin: data.Origin,
		// 	Destination: data.Destination,
		// 	AdultCount: adult,
		// 	ChildCount: child,
		// 	InfantCount: infant,
		// 	PreferredDepartureTime: origin,
		// 	ReturnPreferredDepartureTime: depart,
		// };
		// dispatch(setFormData(formData3));
		// if (trip === 'onetrip') {
		// 	dispatch(SearchFormDispatch(formData, history));
		// } else {
		// 	dispatch(SearchReturnFormDispatch(formData2, history));
		// }
		// console.log(to);
		// console.log(from);
		// console.log(formData);
	};
	console.log(invoiceOptions);
	const handleSearch = (event) => {
		let value = event.target.value.toLowerCase();
		console.log(value);
		if (value.length >= 2) {
			let results =
				invoiceOptions &&
				invoiceOptions.filter((data) => {
					return Object.values(data).join('').toLowerCase().includes(value);
				});
			setResult(results);
		} else {
			setResult([]);
		}
	};
	const handleSearch2 = (event) => {
		let value = event.target.value.toLowerCase();
		let results = [];
		console.log(value);
		if (value.length >= 2) {
			results =
				invoiceOptions &&
				invoiceOptions.filter((data) => {
					return Object.values(data).join('').toLowerCase().includes(value);
				});
			setResult2(results);
		} else {
			setResult2([]);
		}
	};
	console.log(leaving);
	console.log(going);
	const handleChange2 = (e) => {
		console.log(e.target.value);
		dispatch(setTrip(e.target.value));
	};
	return (
		<>
			<Formik
				initialValues={{
					Origin: '',
					Destination: '',
				}}
				validate={(values) => {
					const errors = {};
				}}
				onSubmit={handleSubmit}>
				{({ submitForm, isSubmitting, setFieldValue, values }) => (
					<>
						<Form style={{}}>
							{/* <TitleText textStyle={{ color: 'white', fontSize: 36 }}>
								Book flights and explore the world with us
							</TitleText> */}
							{/* <Box className={classes.radio}>
								<FormControl onChange={handleChange2}>
									<RadioGroup
										row
										aria-labelledby='demo-row-radio-buttons-group-label'
										name='row-radio-buttons-group'>
										<FormControlLabel
											value='oneway'
											control={
												<Radio checked={trip == 'oneway' ? true : false} />
											}
											label='ONE WAY'
										/>
										<FormControlLabel
											value='roundtrip'
											control={
												<Radio checked={trip == 'roundtrip' ? true : false} />
											}
											label='ROUND TRIP'
										/>
									</RadioGroup>
								</FormControl>
							</Box> */}
							<Grid
								container
								spacing={2}
								alignItems='center'
								style={{ marginTop: 10 }}>
								<Grid item xs={12} md={12} lg={3}>
									{/* <Grid container alignItems='center'> */}
									{/* <Grid
											item
											xs={7}
											style={{ display: 'flex', alignItems: 'center' }}> */}
									<div className={classes.root} style={{ width: '100%' }}>
										<span style={{ color: 'white' }}>From</span>
										<Autocomplete
											id='country-select-demo'
											sx={{
												background: '#eee',
												borderRadius: 2,
												padding: '10px',
											}}
											options={result && result.length > 0 ? result : []}
											autoHighlight
											getOptionLabel={(option) => option.code}
											renderOption={(props, option) => (
												<Box
													mr={'5px'}
													component='li'
													sx={{ '& > img': { mr: 2 } }}
													{...props}>
													<img loading='lazy' width='20' src={flt} alt='' />
													<p style={{ fontSize: 13 }}>
														{option.city} ({option.code}) {option.country}
													</p>
												</Box>
											)}
											onChange={(event, value) => {
												setFieldValue('Origin', value.code);
												console.log(value.code);
												// setLeaving(value.code);
											}}
											renderInput={(params) => (
												<TextField
													{...params}
													onChange={handleSearch}
													name='origin'
												/>
											)}
										/>
									</div>
									{/* <SwapHorizontalCircleIcon
										onClick={() => {
											setLeaving(going);
											setGoing(leaving);
											// setData(false);

											// console.log('first');
										}}
										style={{
											color: 'white',
											width: '4em',
											height: '3em',
											marginTop: 20,
											cursor: 'pointer',
										}}
									/> */}
									{/* </Grid> */}
									{/* <Grid item xs={2} style={{ marginTop: 17 }}>
											
										</Grid> */}
									{/* <Grid item xs={5}> */}

									{/* </Grid> */}
									{/* </Grid> */}
								</Grid>
								<Grid item xs={12} md={12} lg={3}>
									<div className={classes.root}>
										<span style={{ color: 'white' }}>To</span>
										<Autocomplete
											id='country-select-demo'
											sx={{
												background: '#eee',
												borderRadius: 2,
												padding: '10px',
											}}
											options={result2 && result2.length > 0 ? result2 : []}
											autoHighlight
											getOptionLabel={(option) => option.code}
											renderOption={(props, option) => (
												<Box
													component='li'
													sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
													{...props}>
													<img loading='lazy' width='20' src={flt} />
													{option.city} ({option.code}) {option.country}
												</Box>
											)}
											onChange={(event, value) => {
												setFieldValue('Destination', value.code);
												// setGoing(value.code);
											}}
											renderInput={(params) => (
												<TextField {...params} onChange={handleSearch2} />
											)}
										/>
									</div>
								</Grid>
								<Grid
									item
									xs={12}
									md={12}
									lg={trip == 'oneway' ? 3 : trip == 'roundtrip' ? 6 : 3}>
									{/* <div className={classes.root}> */}
									<Box display='flex' justifyContent='space-between'>
										<span style={{ color: 'white' }}>Date</span>
										{trip == 'oneway' ? (
											''
										) : trip == 'roundtrip' ? (
											<span style={{ color: 'white' }}>Return Date</span>
										) : (
											''
										)}
										{/* <span style={{ color: 'white' }}>Return Date</span> */}
									</Box>
									{trip == 'oneway' ? (
										<DesktopDateBus />
									) : trip == 'roundtrip' ? (
										<DateRangeNew />
									) : (
										<DesktopDateBus />
									)}
									{/* <DateRangeNew /> */}
									{/* <DesktopDateNew /> */}
									{/* </div> */}
								</Grid>
								{/* <Grid item lg={3}></Grid> */}
								{/* <Grid item xs={12} md={6} lg={6}>
									<ul class='menu' style={{ marginTop: 20, borderRadius: 2 }}>
										<li>
											<a href='#' style={{ padding: 10 }}>
												Travellers,Classes
											</a>

											<ul style={{ width: '100%' }}>
												<li>
													<Box
														style={{ padding: 10 }}
														display='flex'
														justifyContent='space-between'
														textAlign='center'
														alignItems='center'>
														<BodyText four textStyle={{ color: 'white' }}>
															Adult
														</BodyText>
														<Box display='flex' alignItems='center'>
															<Box
																style={{
																	cursor: 'pointer',
																}}
																onClick={() =>
																	adult === 0 ? '' : setAdult(adult - 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 24,
																		color: 'white',
																	}}>
																	-
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																}}>
																<BodyText
																	textStyle={{ fontSize: 24, color: 'white' }}>
																	{adult}
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																}}
																onClick={() =>
																	adult === 9 ? '' : setAdult(adult + 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 24,
																		color: 'white',
s																	}}>
																	+
																</BodyText>
															</Box>
														</Box>
													</Box>
												</li>
												<li>
													<Box
														style={{ padding: 10 }}
														display='flex'
														justifyContent='space-between'
														textAlign='center'
														alignItems='center'>
														<BodyText four textStyle={{ color: 'white' }}>
															Child
														</BodyText>
														<Box display='flex' alignItems='center'>
															<Box
																style={{
																	cursor: 'pointer',
																}}
																onClick={() =>
																	adult === 0 ? '' : setAdult(adult - 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 24,
																		color: 'white',
																	}}>
																	-
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																}}>
																<BodyText
																	textStyle={{ fontSize: 24, color: 'white' }}>
																	{adult}
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																}}
																onClick={() =>
																	adult === 9 ? '' : setAdult(adult + 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 24,
																		color: 'white',
																	}}>
																	+
																</BodyText>
															</Box>
														</Box>
													</Box>
												</li>
												<li>
													<Box
														style={{ padding: 10 }}
														display='flex'
														justifyContent='space-between'
														textAlign='center'
														alignItems='center'>
														<BodyText four textStyle={{ color: 'white' }}>
															Infant
														</BodyText>
														<Box display='flex' alignItems='center'>
															<Box
																style={{
																	cursor: 'pointer',
																}}
																onClick={() =>
																	adult === 0 ? '' : setAdult(adult - 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 24,
																		color: 'white',
																	}}>
																	-
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																}}>
																<BodyText
																	textStyle={{ fontSize: 24, color: 'white' }}>
																	{adult}
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																}}
																onClick={() =>
																	adult === 9 ? '' : setAdult(adult + 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 24,
																		color: 'white',
																	}}>
																	+
																</BodyText>
															</Box>
														</Box>
													</Box>
												</li>
												<li>
													<Box
														style={{ padding: 10 }}
														display='flex'
														justifyContent='space-between'>
														<Box className={classes.radio}>
															<FormControl component='fieldset'>
																<RadioGroup
																	aria-label='gender'
																	name='gender1'
																	value={value}
																	color='white'
																	onChange={handleRadio}>
																	<FormControlLabel
																		value='Economy'
																		control={<Radio />}
																		label='Economy'
																	/>
																	<FormControlLabel
																		value='Business'
																		control={<Radio />}
																		label='Business'
																	/>
																	<FormControlLabel
																		value='First Class'
																		control={<Radio />}
																		label='First Class'
																	/>
																	<FormControlLabel
																		value='Premium Economy'
																		control={<Radio />}
																		label='Premium Economy'
																	/>
																</RadioGroup>
															</FormControl>
														</Box>
													</Box>
												</li>
											</ul>
										</li>
									</ul>
								</Grid> */}
								<Grid item xs={12} md={6} lg={3} style={{ marginTop: 12 }}>
									<input
										type='submit'
										value='book now'
										className='btn'
										style={{ width: '100%', borderRadius: 12, fontSize: 30 }}
									/>
								</Grid>
							</Grid>
						</Form>
					</>
				)}
			</Formik>
		</>
	);
};

export default SearchBus2;
